import { Path } from '..';
import { config } from '../config';
import { biLogger } from '../bi';
import { AppMarketWidget, } from '@wix/app-market-collection-widget';
import { AppMarketPage } from '../types/common/marketplace';
export var getPathForBi = function (path) {
    return path === Path.HOME || ''
        ? AppMarketPage.HOMEPAGE
        : path === Path.WEB_SOLUTION
            ? AppMarketPage.APP_PAGE
            : path;
};
export var getWidgetReferral = function () {
    var _a;
    // @ts-ignore
    return (((_a = config === null || config === void 0 ? void 0 : config.goBackToReferrer) === null || _a === void 0 ? void 0 : _a.referrerNameForBI) &&
        Object.values(AppMarketWidget).includes(
        // @ts-ignore
        config.goBackToReferrer.referrerNameForBI) &&
        config.goBackToReferrer.referrerNameForBI);
};
export var getReferralInfo = function (referral, route) {
    if (referral) {
        return referral;
    }
    if (route && route.path) {
        return getPathForBi(route.path);
    }
    if (config.goBackToReferrer) {
        return config.goBackToReferrer.referrerNameForBI;
    }
    if (route) {
        return AppMarketPage.HOMEPAGE;
    }
};
export var getTagName = function (route) {
    return (route === null || route === void 0 ? void 0 : route.slug) || (route === null || route === void 0 ? void 0 : route.query) || AppMarketPage.HOMEPAGE;
};
export var getRouteForBi = function (route, prevRoute) {
    var res = {};
    res.market = config.originForBI;
    res.tagName = getTagName(route);
    res.tagType = getPathForBi(route.path);
    res.subCategory = route.subCategories && route.subCategories.join(',');
    res.referralInfo = getReferralInfo(route.referral, prevRoute);
    (res.section = route === null || route === void 0 ? void 0 : route.section),
        (res.searchTerm = route.query ? route.query : prevRoute && prevRoute.query);
    res.widgetReferral = getWidgetReferral();
    res.collimp_id = route === null || route === void 0 ? void 0 : route.collimp_id;
    return res;
};
export var sendAppPageImpressionsBi = function (pageSection, sectionIndex, appId) {
    biLogger.appMarketAppPageScrollPage({
        app_id: appId,
        page_part: pageSection,
        page_part_index: sectionIndex,
        tag_name: 'app_page',
    });
};
//# sourceMappingURL=bi-events.js.map